const AvatarContainerStyle = `
  justify-items: center;
`;

export default AvatarContainerStyle;
